import { CmsPage } from '@/components/CmsInterfaces';
import Footer from '@/components/Footer';
import Header from '@/components/Header';
import { Layout, LayoutVariant } from '@/components/Layout';
import NewsOverview from '@/components/NewsOverview';
import Page from '@/components/Page';

interface PageNewsProps extends CmsPage {
  title: string;
}

export default class PageNews extends Page<PageNewsProps> {
  render() {
    const { title, path } = this.props;
    const variant = LayoutVariant.FullWidth;
    return (
      <>
        <Header />
        <main className="page page--default">
          <Layout variant={variant} path={path}>
            <NewsOverview title={title} />
          </Layout>
          <Footer />
        </main>
      </>
    );
  }
}
